/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { applicationAdminControllerDeleteV1 } from '../fn/application-admin/application-admin-controller-delete-v-1';
import { ApplicationAdminControllerDeleteV1$Params } from '../fn/application-admin/application-admin-controller-delete-v-1';
import { applicationAdminControllerFindByIdV1 } from '../fn/application-admin/application-admin-controller-find-by-id-v-1';
import { ApplicationAdminControllerFindByIdV1$Params } from '../fn/application-admin/application-admin-controller-find-by-id-v-1';
import { applicationAdminControllerSearchV1 } from '../fn/application-admin/application-admin-controller-search-v-1';
import { ApplicationAdminControllerSearchV1$Params } from '../fn/application-admin/application-admin-controller-search-v-1';
import { applicationAdminControllerUpdateMemoV1 } from '../fn/application-admin/application-admin-controller-update-memo-v-1';
import { ApplicationAdminControllerUpdateMemoV1$Params } from '../fn/application-admin/application-admin-controller-update-memo-v-1';
import { applicationAdminControllerUpdateStatusV1 } from '../fn/application-admin/application-admin-controller-update-status-v-1';
import { ApplicationAdminControllerUpdateStatusV1$Params } from '../fn/application-admin/application-admin-controller-update-status-v-1';
import { ApplicationDto } from '../models/application-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class ApplicationAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `applicationAdminControllerSearchV1()` */
  static readonly ApplicationAdminControllerSearchV1Path = '/api/v1/applications/admin';

  /**
   * 참가 신청 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applicationAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationAdminControllerSearchV1$Response(params: ApplicationAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ApplicationDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = applicationAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 참가 신청 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `applicationAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationAdminControllerSearchV1(params: ApplicationAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<ApplicationDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.applicationAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ApplicationDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ApplicationDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `applicationAdminControllerFindByIdV1()` */
  static readonly ApplicationAdminControllerFindByIdV1Path = '/api/v1/applications/admin/{id}';

  /**
   * 참가 신청 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applicationAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationAdminControllerFindByIdV1$Response(params: ApplicationAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationDto>> {
    const obs = applicationAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 참가 신청 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `applicationAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationAdminControllerFindByIdV1(params: ApplicationAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<ApplicationDto> {
    const resp = this.applicationAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ApplicationDto>): ApplicationDto => r.body)
    );
  }

  /** Path part for operation `applicationAdminControllerDeleteV1()` */
  static readonly ApplicationAdminControllerDeleteV1Path = '/api/v1/applications/admin/{id}';

  /**
   * 참가 신청 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applicationAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationAdminControllerDeleteV1$Response(params: ApplicationAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = applicationAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 참가 신청 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `applicationAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applicationAdminControllerDeleteV1(params: ApplicationAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.applicationAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `applicationAdminControllerUpdateStatusV1()` */
  static readonly ApplicationAdminControllerUpdateStatusV1Path = '/api/v1/applications/admin/{id}/status';

  /**
   * 참가 신청 상태 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applicationAdminControllerUpdateStatusV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  applicationAdminControllerUpdateStatusV1$Response(params: ApplicationAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = applicationAdminControllerUpdateStatusV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 참가 신청 상태 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `applicationAdminControllerUpdateStatusV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  applicationAdminControllerUpdateStatusV1(params: ApplicationAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.applicationAdminControllerUpdateStatusV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `applicationAdminControllerUpdateMemoV1()` */
  static readonly ApplicationAdminControllerUpdateMemoV1Path = '/api/v1/applications/admin/{id}/memo';

  /**
   * 참가 신청 메모 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applicationAdminControllerUpdateMemoV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  applicationAdminControllerUpdateMemoV1$Response(params: ApplicationAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = applicationAdminControllerUpdateMemoV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 참가 신청 메모 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `applicationAdminControllerUpdateMemoV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  applicationAdminControllerUpdateMemoV1(params: ApplicationAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.applicationAdminControllerUpdateMemoV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
